<template>
	<section v-if="items.length" class="promotions align-center background-dark">
		<slot name="blocks-header" />
		<div class="row">
			<div v-for="block in items.slice(0, amount)" :key="block.ID" class="columns column4">
				<div class="promotion">
					<div class="image">
						<nuxt-link :to="block.link" target="_self">
							<picture>
								<source :srcset="block.imageWebp" type="image/webp" />
								<source :srcset="block.image" />
								<img :src="block.image" :alt="block.imageAlt" loading="lazy" />
							</picture>
						</nuxt-link>
					</div>
					<div class="content">
						<h3>
							<nuxt-link :to="block.link" target="_self">
								{{ block.header }}
							</nuxt-link>
						</h3>
						<div v-parse-links v-html="block.content" />
						<nuxt-link :to="block.link" class="button" target="_self">
							{{ block.button }}
						</nuxt-link>
					</div>
				</div>
			</div>
		</div>
	</section>
</template>

<script setup>
defineProps({
	items: { type: Array, default: () => [] },
	amount: { type: Number, default: 3 },
});
</script>

<style lang="scss" scoped>
.row {
	justify-content: center;
}

.promotions .columns {
	display: flex;
}

.promotion {
	background-color: var(--primary-background-color);
	margin: 0 auto 20px;
	position: relative;
	overflow: hidden;
	width: 100%;
	padding: 15px;

	.content {
		padding: 45px 30px 80px;

		:deep(h3) {
			font-size: 24px;
		}

		h3 a,
		a h3,
		h3 a span {
			text-decoration: none;
			color: var(--header-color);
			font-size: inherit;
		}

		.button {
			position: absolute;
			left: 45px;
			bottom: 40px;
		}
	}

	.image {
		display: block;
		overflow: hidden;
		position: relative;

		&::before {
			content: '';
			display: block;
			position: absolute;
			inset: 0;
			background: #000;
		}

		img {
			transition: all 0.3s ease-in-out;
			background: #000;
			opacity: 0.8;
			z-index: 1;
			position: relative;
			width: 100%;
			height: 100%;
			object-fit: cover;
		}

		&:hover img {
			opacity: 1;
		}
	}
}

@media (max-width: 580px) {
	.promotion {
		.content {
			text-align: center;

			.button {
				left: 45px;
				right: 45px;
			}
		}
	}
}
</style>
